import React, { Component } from 'react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { connect } from 'react-redux'
import BankrollTab from 'components/profile/BankrollTab'
import BookmakersTab from 'components/profile/BookmakersTab'
import AccountTab from 'components/profile/AccountTab'
import NotificationsTab from 'components/profile/NotificationsTab'
import 'css/profiles.less'

class ProfileContainer extends Component {
  constructor(props) {
    super(props)
  }


  componentDidMount() {
    window.analytics.page('Profile')
  }

  render() {
    return (
      <div className='col-md-8 col-md-offset-2 col-xs-12'>
        <div className='panel profile'>
          <div className='panel-body'>
            <Tabs>
              <TabList>
                <Tab>BANKROLL</Tab>
                <Tab>BOOKMAKERS</Tab>
                <Tab>NOTIFICATIONS</Tab>
                <Tab>ACCOUNT</Tab>
              </TabList>
              <TabPanel>
                <BankrollTab
                  dispatch={ this.props.dispatch }
                  currencies={ Object.keys(this.props.currencies) }
                  currency={ this.props.user.currency}
                  startingBankroll={ this.props.user.startingBankroll }
                  kellyFrac={ this.props.user.kellyFrac }
                  userId={ this.props.user.id }
                  />
              </TabPanel>
              <TabPanel>
                <BookmakersTab user={this.props.user}/>
              </TabPanel>
              <TabPanel>
                <NotificationsTab user={this.props.user} />
              </TabPanel>
              <TabPanel>
                <AccountTab
                  email={ this.props.user.email }
                  verified={ this.props.user.verified }
                  forumName={ this.props.user.forumName }
                  dispatch={ this.props.dispatch }
                  userId={ this.props.user.id }
                  createdAt={ this.props.user.createdAt }
                  />
              </TabPanel>
            </Tabs>
          </div>
        </div>
      </div>
    );
  }
}

export default connect(state => {
  return {
    currencies: state.currencies
  }
})(ProfileContainer)



/** WEBPACK FOOTER **
 ** ./src/containers/ProfileContainer.js
 **/